import { CurecallModalContainer } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'
import MedicalStaffMemberFormComponent from './medical-staff-member-form.component'
import { TMedicalStaffMember } from 'src/types/medical-staff-member'

export type Props = {
  isOpen: boolean
  onCancel: () => void
  selectedMedicalStaffMember?: TMedicalStaffMember
}

export default function MedicalStaffMemberFormModal({
  isOpen,
  onCancel,
  selectedMedicalStaffMember,
}: Readonly<Props>) {
  const { t } = useTranslation()

  return (
    <>
      <CurecallModalContainer
        title={
          selectedMedicalStaffMember
            ? t('pages.users-page.update-medical-staff-member')
            : t('pages.users-page.add-medical-staff-member')
        }
        isOpen={isOpen}
        toggle={() => {
          onCancel()
        }}
        closeModalAriaLabel={t('pages.users-page.cta-close')}
        dialogClassName="c-w-[900px]"
      >
        <MedicalStaffMemberFormComponent
          onCancel={onCancel}
          selectedMedicalStaffMember={selectedMedicalStaffMember}
        />
      </CurecallModalContainer>
    </>
  )
}
